/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used in the All Components screen.
 * @export
 */
export const ALL_COMPONENTS_DATA_IDS = {
  componentDescription: `Component description`,
  componentIcon: `Component icon`,
  componentTitle: `Component title`,
  componentWebpath: `Component web-path`,
  list: `All components list`,
};

export const ALL_COMPONENTS_CONSTANTS = {
  maxDescriptionLength: 100,
  maxDisplayNameLength: 60,
};
